import { c as _c } from "react/compiler-runtime";
import { FlexColumn, Skeleton, TableCell, TableRow } from "@opensea/ui-kit";
import { range } from "es-toolkit";
import { RECEIPT_TABLE_COLUMN_CLASSNAMES } from "./constants";
export const ReceiptTotalDisplaySkeleton = t0 => {
  const $ = _c(4);
  const {
    count: t1
  } = t0;
  const count = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== count) {
    t2 = range(count).map(_temp);
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <>{t2}</>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
function _temp(index) {
  return <TableRow key={index}><TableCell className={RECEIPT_TABLE_COLUMN_CLASSNAMES.item}><Skeleton className="w-16" /></TableCell><TableCell className={RECEIPT_TABLE_COLUMN_CLASSNAMES.price}><FlexColumn className="items-end gap-1"><Skeleton className="w-16" /><Skeleton className="w-20" /></FlexColumn></TableCell></TableRow>;
}